import { render, staticRenderFns } from "./HomeProjectList.vue?vue&type=template&id=5838f784&"
import script from "./HomeProjectList.vue?vue&type=script&lang=js&"
export * from "./HomeProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports